module.exports = __webpack_public_path__ + "a6aa062bdf8cb4bdf494355c6e8c70e0.mp4";